//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GDialog from "@/common/components/g-dialog/"
import GMarquee from "@/common/components/g-marquee/"
import { getPushInfoList } from '@/common/api/normal.js'
var dialoTitleOption = {
  en_US: 'Announcement',
  hi_IN: 'घोषणा ',
  zh_CN: '公告'
}
export default {
  components: { GMarquee, GDialog },
  data() {
    return {
      show: false,
      list: [],
      content: null,
      dialoTitle: '公告'
    }
  },
  created() {
    this.handleFetch()
  },
  mounted() {
    this.$nextTick(() => {
      this.dialoTitle = dialoTitleOption[this.$store.state.langs.keys]
    })
  },
  methods: {
    handleFetch(){
      getPushInfoList().then(([data, err]) => { // 轮播公告
        if(!err){
          if (data.list && data.list.length) {
            this.list = data.list
            this.content = ''
            this.list.forEach((item, index) => {
              // this.content += `${index + 1}. ${item.name}:${item.content}`
              this.content += `${item.content}`
            })
            this.$store.commit('setPushList', data.list)
          } else {
            this.content = this.$t('home').welcome
          }
        } else {
          this.content = this.$t('home').welcome
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/components/p-notice/index.vue